module.exports = __webpack_public_path__ + "static/media/empty-avatar.8cb04c92.png";